export enum StudentType {
  VIRTUAL = 'VIRTUAL',

  PRESENCIAL = 'PRESENCIAL',
}
